<template>
  <section class="content">
    <admin-header
      :title="'Party Groups'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminPartyGroup',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Party Groups',
        searchEntityScreen: 'Admin - Party Group search',
        filterEventName: 'admin-party-group-filter',
        filterName: 'PartyGroupFilter',
        entityName: 'party-group'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/PartyGroup/AdminPartyGroup.vue